<template lang="html">
  <section class="ctn-patrimonial-landscape no-edit">
		<div class="heading-sub-client row">
			<router-link :to="{name: 'Client', params: { clientId: client.id}}" class="btn-icon">
				<span class="icon-arrow-back"></span>
			</router-link>
			<div class="label">
				Paysage Patrimonial de {{ client.firstname }} {{ client.lastname }}
			</div>
		</div>
		<div class=""><br /></div>
		<display></display>
  </section>
</template>

<script>
import display from '@/common/components/MyPatrimonialLandscape/Display'
export default {
	name: 'PatrimonialLandscape',
	components: {
		display
	},
	data () {
		return {
			client: this.$store.getters.getClient(this.$route.params.clientId)
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// PatrimonialLandscape.vue?5e3549be